import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import MindsetsJsSDK from "mindsets-js-sdk";

export default function () {
    const messagesARun = 10;
    const runsEverySeconds = 15;
    const dispatch = useDispatch();
    const queue_attributes = useSelector(state => state.queue_attributes);
    const [seconds, setSeconds] = useState(0);

    function LoadQueueAttributesAction() {
        MindsetsJsSDK().API.get(`queue/attributes`).then(response => {
            dispatch({
                type: 'queue_attributes',
                payload: response.attributes
            });
        });
    }

    function countDown() {
        setSeconds(seconds - 1);
    }

    useEffect(() => {
        LoadQueueAttributesAction();
        const interval = setInterval(LoadQueueAttributesAction, 1000 * 60);

        return () => {
            clearInterval(interval);
        }
    }, []);

    useEffect(() => {
        if (seconds > 0) {
            const timerId = setTimeout(countDown, 1000);

            return () => clearTimeout(timerId);
        }
    }, [seconds]);

    function formatTime(seconds) {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const remainingSeconds = seconds % 60;

        const formattedHours = String(hours).padStart(2, '0');
        const formattedMinutes = String(minutes).padStart(2, '0');
        const formattedSeconds = String(remainingSeconds).padStart(2, '0');

        return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
    }

    useEffect(() => {
        if (queue_attributes.ApproximateNumberOfMessages > 0) {
            setSeconds(queue_attributes.ApproximateNumberOfMessages * runsEverySeconds / messagesARun);
        }
    }, [queue_attributes.ApproximateNumberOfMessages]);

    return (
        <div>
            <span>
                <strong>Responses in the queue for grading:</strong> {queue_attributes.ApproximateNumberOfMessages}
            </span>
            <span> | </span>
            <span>
                <strong>ETA:</strong> {formatTime(seconds)}
            </span>
        </div>
    );
};
